'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddIcon = function AddIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M17,15 L17,5.001 C17,4.448 16.574,4 16.021,4 C15.468,4 15.021,4.447 15.021,4.999 L15.012,15 L5,15 C4.447,15 4,15.447 4,16 C4,16.552 4.447,17 5,17 L15.01,17 L15,26.999 C14.999,27.551 15.446,27.999 15.998,28 C16.551,28 16.999,27.553 17,27.001 L17,17 L27,17 C27.552,17 28,16.552 28,16 C28,15.447 27.552,15 27,15 L17,15 Z' })
  );
};

AddIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = AddIcon;